import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Typography, Breadcrumb, Space, Divider, Grid, Collapse, Card } from 'antd';
// import Proposal from '../../assets/doc/Proposal.pdf';

const { Text } = Typography;
const { Panel } = Collapse;
const { useBreakpoint } = Grid;

function Sponsorship() {
  const { xs } = useBreakpoint()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={32} style={{ backgroundColor: '#fff', paddingBottom: 0 }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Sponsorship</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 16 : 32}>
            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
              <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Sponsorship</Text>
              <Text style={{ fontSize: 23, color: '#373737' }}>Why Sponsor?</Text>
            </Space>
            <Space direction="vertical" size={16}>
              <Text style={{ fontSize: 15 }}>The 2nd WCHSS committee is fully aware that this conference will not be successful without the support and participation of all parties concerned. Therefore, we intend to offer cooperation with businesses and institutions for the success of this event, participating as a sponsor. The First World Conference on Health and Social Sciences has several sponsorship packages available, providing sponsors with a choice of exposure related to financial commitment. Sponsoring the First World Conference on Health and Social Sciences presents an opportunity for stakeholders within the industry to highlight their commitment and support to this health, business and work sector. It offers your organisation:</Text>
              <ul style={{ marginLeft: -24 }}>
                <li><Text style={{ fontSize: 16 }}>Marketing opportunities and international exposure during the entire life of the event;</Text></li>
                <li><Text style={{ fontSize: 16 }}>Access to approximately 200 influential and engaged delegates;</Text></li>
                <li><Text style={{ fontSize: 16 }}>Connections with leading industry professionals;</Text></li>
                <li><Text style={{ fontSize: 16 }}>the chance to unlock and share knowledge; and</Text></li>
                <li><Text style={{ fontSize: 16 }}>The opportunity to support attendance of leading professionals from developing countries</Text></li>
              </ul>
              <Text style={{ fontSize: 15 }}>Packages have been developed to maximise exposure and activities for all sponsors and we are more than happy to tailor any of them to suit your required benefits and budget. All Packages include:</Text>
              <ul style={{ marginLeft: -24 }}>
                <li><Text style={{ fontSize: 16 }}>Promotional and branding opportunities;</Text></li>
                <li><Text style={{ fontSize: 16 }}>corporate networking; and</Text></li>
                <li><Text style={{ fontSize: 16 }}>Marketing opportunities.</Text></li>
              </ul>
            </Space>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Space direction="vertical" size={xs ? 16 : 32} style={{ width: '100%' }}>
            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
              <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Sponsorship Categories</Text>
            </Space>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 8 : 32} style={{ width: '100%' }}>
            <Space direction="vertical" size={0} style={{ width: '100%' }}>
              <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#E5BB66' }}>Principal Sponsor</Text>
              {/* <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#0F6F4B' }}>IDR 150.000.000,00</Text> */}
              <Collapse className="collapse-sponsorship" bordered={false} ghost defaultActiveKey={['1']} style={{ marginLeft: -16 }}>
                <Panel header={<Text style={{ fontSize: 23, fontWeight: 'bold' }}>Benefits</Text>} key="1">
                  <ul style={{ marginLeft: -24 }}>
                    <li><Text style={{ fontSize: 16 }}>Two (2) x complimentary registrations including all catering, all conference sessions and social functions</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Two (2) x complimentary Cultural Dinner tickets</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company’s logo and name will be published on outdoor banner, indoor banner, welcoming banner, backdrop, banner in ballroom conference, banner in parallel session rooms, seminar kit, and conference guideline’s book</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor recognition and link from the event page on the WCHSS web site</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company name mentioned in all media advertising: printed and online</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Speaking opportunity at the Cultural Dinner</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor advertisement in event program by MC</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Promoting session of Jingle product</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Stand promotion during the conference</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Crystal trophy recognition as a principal sponsor</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Providing the products during the conference program</Text></li>
                  </ul>
                </Panel>
              </Collapse>
            </Space>
            <Space direction="vertical" size={0} style={{ width: '100%' }}>
              <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#E5BB66' }}> Supporting Sponsor</Text>
              {/* <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#0F6F4B' }}>IDR 100.000.000,00</Text> */}
              <Collapse className="collapse-sponsorship" bordered={false} ghost defaultActiveKey={['1']} style={{ marginLeft: -16 }}>
                <Panel header={<Text style={{ fontSize: 23, fontWeight: 'bold' }}>Benefits</Text>} key="1">
                  <ul style={{ marginLeft: -24 }}>
                    <li><Text style={{ fontSize: 16 }}>Two (2) x complimentary Cultural Dinner tickets</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company’s logo and name will be published on outdoor banner, indoor banner, welcoming banner, backdrop, banner in ballroom conference, banner in parallel session rooms, seminar kit, and conference guideline’s book</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor recognition and link from the event page on the WCHSS web site</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company name mentioned in all media advertising: printed and online</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor advertisement in event program by MC</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Promoting session of Jingle product</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Stand promotion during the conference</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Crystal trophy recognition as a principal sponsor</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Providing the products during the conference program</Text></li>
                  </ul>
                </Panel>
              </Collapse>
            </Space>
            <Space direction="vertical" size={0} style={{ width: '100%' }}>
              <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#E5BB66' }}> Participating Sponsor</Text>
              {/* <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#0F6F4B' }}>IDR 50.000.000,00</Text> */}
              <Collapse className="collapse-sponsorship" bordered={false} ghost defaultActiveKey={['1']} style={{ marginLeft: -16 }}>
                <Panel header={<Text style={{ fontSize: 23, fontWeight: 'bold' }}>Benefits</Text>} key="1">
                  <ul style={{ marginLeft: -24 }}>
                    <li><Text style={{ fontSize: 16 }}>One (1) x complimentary Cultural Dinner tickets</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company’s logo and name will be published on outdoor banner, indoor banner, welcoming banner, backdrop, banner in ballroom conference, banner in parallel session rooms, seminar kit, and conference guideline’s book</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor recognition and link from the event page on the WCHSS web site</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company name mentioned in all media advertising: printed and online</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor advertisement in event program by MC</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Providing the products during the conference program</Text></li>
                  </ul>
                </Panel>
              </Collapse>
            </Space>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24}>
          <Space direction="vertical" style={{ width: '100%', textAlign: 'center', marginBottom: 16 }}>
            <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Packages</Text>
          </Space>
          <Card style={{ width: '100%', backgroundColor: '#e8ebed', borderRadius: 12, boxShadow: '0 2px 8px 1px #f1f3f4' }}>
            <Row justify="space-around" align="middle" gutter={[0,8]} style={{ textAlign: 'center', marginBottom: xs ? 16 : 32 }}>
              <Col span={24}>
                <Space direction='vertical' size={0} style={{ fontWeight: 500 }}>
                  <Text style={{ fontSize: 23 }}>Additional Opportunities</Text>
                </Space>
              </Col>
            </Row>
            <Row justify="space-around" align="middle" gutter={xs ? 16 : 32}>
              <Col xs={24} lg={12}>
                <Space direction="vertical" size={16}>
                  {
                    xs ? 
                      <Space direction='vertical' size={0}>
                        <Text style={{ fontSize: 15 }}>Cultural Dinner Sponsor</Text>
                        {/* <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR. 25.000.000</Text> */}
                      </Space>
                    :
                      <Space>
                        <Text style={{ fontSize: 15 }}>Cultural Dinner Sponsor |</Text>
                        {/* <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR. 25.000.000</Text> */}
                      </Space>
                  }
                  <ul style={{ marginLeft: -24 }}>
                    <li><Text style={{ fontSize: 16 }}>Your organisation’s logo will appear on seminar kit</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company’s logo and name will be published on backdrop & banner in ballroom conference</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor recognition and link from the event page on the WCHSS web site and social media</Text></li>
                  </ul>
                </Space>
              </Col>
              <Col xs={24} lg={12}>
                <Space direction="vertical" size={16}>
                  {
                    xs ? 
                      <Space direction='vertical' size={0}>
                        <Text style={{ fontSize: 15 }}>Seminar Kit Sponsor</Text>
                        {/* <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR. 25.000.000</Text> */}
                      </Space>
                    :
                      <Space>
                        <Text style={{ fontSize: 15 }}>Seminar Kit Sponsor |</Text>
                        {/* <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR. 25.000.000</Text> */}
                      </Space>
                  }
                  <ul style={{ marginLeft: -24 }}>
                    <li><Text style={{ fontSize: 16 }}>Your organisation’s logo will appear on seminar kit</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Company’s logo and name will be published on backdrop & banner in ballroom conference</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor recognition and link from the event page on the WCHSS web site and social media</Text></li>
                  </ul>
                </Space>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24} style={{ marginTop: 16 }}>
          <Space direction='vertical'>
            <Text style={{ fontSize: 23, fontWeight: 500 }}>Co-partnership</Text>
            <Space direction='vertical' size={0}>
              <Text style={{ fontSize: 16 }}>Other packages such as company’s products, publications, etc. will be discussed.</Text>
              <Text style={{ fontSize: 16 }}>We are more than happy to tailor the above package to suit your desired benefits and budget whilst maximising your exposure.</Text>
            </Space>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 16 : 32}>
            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
              <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Payment & Conditions</Text>
            </Space>
            <Space direction="vertical" size={xs ? 16 : 32}>
              <ul style={{ marginLeft: -24 }}>
                <li><Text style={{ fontSize: 16 }}>All prices listed are in Indonesia Rupiah.</Text></li>
                <li><Text style={{ fontSize: 16 }}>All payments must be made in Indonesia Rupiah.</Text></li>
                <li><Text style={{ fontSize: 16 }}>Bank cheques, direct transfers and credit card payments will be accepted.</Text></li>
              </ul>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Sponsors’ responsibilities</Text>
                <Text style={{ fontSize: 16 }}>It is the responsibility of sponsors to provide the materials listed in the package, once the commitment has been made. The companies which get the most out of their sponsorship are those who actively promote their presence at the conference and provide any required materials in a timely manner.</Text>
              </Space>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Sponsor agreements</Text>
                <Text style={{ fontSize: 16 }}>Once your preferred sponsorship package has been negotiated, the conference team will prepare a Sponsor Agreement for your signature. The Agreement is to be signed and returned within the timeframe specified.</Text>
              </Space>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Sponsorship cancellation policy</Text>
                <Text style={{ fontSize: 16 }}>Sponsorship cancellations must be made in writing. Please note that the detailed cancellation policy will be outlined in the Terms & Conditions included with the Sponsor Agreement.</Text>
              </Space>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Disclaimer</Text>
                <Space direction='vertical' size={0}>
                  <Text style={{ fontSize: 16 }}>The entitlements listed in this document are offered on the basis that confirmation of a sponsor’s involvement is received prior to the deadline specified by the conference team. The 2nd WCHSS has the right to amend these packages subject to change in the program format.</Text>
                  <Text style={{ fontSize: 16 }}>Pease contact us with any question.</Text>
                </Space>
              </Space>
            </Space>
          </Space>
        </Col>
        {/* {
          xs ?
            <Col span={24} style={{ textAlign: 'center', marginTop: 16 }}>
              <Space direction='vertical'>
                  <Text>Click Here to</Text>
                  <Link to={Proposal} target="_blank" download>
                    <Button className='button-green'>Download here</Button>
                  </Link>
              </Space>
            </Col>
          :
            <Col span={24} style={{ float: 'right' }}>
              <Space style={{ float: 'right' }}>
                  <Text>Click Here to</Text>
                  <Link to={Proposal} target="_blank" download>
                    <Button className='button-green'>Download here</Button>
                  </Link>
              </Space>
            </Col>
        } */}
        
      </Row>
    </React.Fragment>
  )
}

export default Sponsorship